module.exports = __webpack_public_path__ + "img/mobilecase.cd275846.png";